module.exports = Jsw.skinUrl + "/icons/64/plesk/plesk.png?aee4fcbe66c643d3dde4f3de15aa8f4e";